// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SupplyTypeDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class SupplyTypeApiClient extends BaseCRUDApiClient<SupplyTypeDto> {
  baseUrl = this.config.apiEndpoint + '/supply-type';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
